import { KyInstance } from 'ky';

import { VITE_PLUGIN_SERVICE_URL } from '@/constants/env';
import { handleRequest } from '@/utils/httpUtils';

import {
  CreateOrder,
  CreateOrderResponse,
  DeletePlugin,
  GenerateGuides,
  GetPluginDetails,
  GetUserPlugins,
  Install,
  // OAuth, // No se usa - el backend gestiona el OAuth internamente
  Order,
  OrderResponse,
  Orders,
  OrdersResponse,
  ProcessOrders,
  UpdatePlugin,
  ValidateRate,
  ValidateRateResponse,
} from './types';

export interface IReqEnvioFlex {
  orders: Orders;
  order: Order;
  generateGuides: GenerateGuides;
  install: Install;
  // oauth: OAuth; // No se usa - el backend gestiona el OAuth internamente
  validateRate: ValidateRate;
  createOrder: CreateOrder;
  getUserPlugins: GetUserPlugins;
  getPluginDetails: GetPluginDetails;
  updatePlugin: UpdatePlugin;
  deletePlugin: DeletePlugin;
  processOrders: ProcessOrders;
}

export function reqEnvioFlex(http: KyInstance): IReqEnvioFlex {
  const route = 'api/v3/mercadolibre/flex';
  return {
    orders: ({ page, pageSize, clientId, dateFrom, dateTo, orderId, status }) =>
      handleRequest<OrdersResponse>(http, 'get', `${route}/orders`, {
        searchParams: {
          ...(page !== undefined && { page }),
          ...(pageSize !== undefined && { pageSize }),
          ...(status && { status }),
          ...(dateFrom && { dateFrom }),
          ...(dateTo && { dateTo }),
          ...(orderId && { orderId }),
        },
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    order: ({ orderId, clientId }) =>
      handleRequest<OrderResponse>(http, 'get', `${route}/orders/${orderId}`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    generateGuides: ({ clientId, orderIds }) =>
      handleRequest(http, 'post', `${route}/generate-guides`, {
        json: { orderIds },
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    install: ({ country, clientId }) => {
      const baseUrl = new URL(`${route}/install/${country}`, VITE_PLUGIN_SERVICE_URL);
      baseUrl.searchParams.set('X-Client-ID', String(clientId));
      window.location.href = baseUrl.toString();
      return Promise.resolve();
    },
    // oauth: No se usa - el backend gestiona el OAuth internamente
    // El backend:
    // 1. Recibe /install → redirige a Mercado Libre
    // 2. Mercado Libre redirige al backend /callback con code y state
    // 3. Backend procesa OAuth y redirige al frontend con ?success=true o ?success=false&traceId=...
    validateRate: ({ clientId, orderId }) =>
      handleRequest<ValidateRateResponse>(http, 'post', `${route}/orders/rate`, {
        json: { id: orderId },
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    createOrder: ({ clientId, orderId }) =>
      handleRequest<CreateOrderResponse>(http, 'post', `${route}/orders/create`, {
        json: { id: orderId },
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    getUserPlugins: ({ clientId }) =>
      handleRequest(http, 'get', 'api/v3/user/plugins', {
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    getPluginDetails: ({ clientId, pluginId }) =>
      handleRequest(http, 'get', `api/v3/user/plugins/${pluginId}/details`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    updatePlugin: ({ clientId, pluginId, data }) =>
      handleRequest(http, 'patch', `api/v3/user/plugins/${pluginId}/update`, {
        json: data,
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    deletePlugin: ({ clientId, pluginId }) =>
      handleRequest(http, 'delete', `api/v3/user/plugins/${pluginId}/delete`, {
        headers: {
          'X-Client-ID': clientId,
        },
      }),
    processOrders: ({ clientId, orderIds }) =>
      handleRequest(http, 'post', `${route}/orders/process`, {
        json: orderIds,
        headers: {
          'X-Client-ID': clientId,
        },
      }),
  };
}
